// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { classNames } from '@shared/ui-kit/utils/classnames';
import { type ComponentProps, type FC } from 'react';

export const ScreenLayout: FC<
  ComponentProps<'div'> & { actions?: React.ReactNode }
> = ({ children, className, actions }) => (
  <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
    <div
      className={classNames(
        'flex min-h-0 flex-1 flex-col overflow-y-auto px-9 pb-12 pt-9',
        className,
      )}
    >
      {children}
    </div>
    {actions}
  </div>
);
